import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/chart";
import { dailyLabelFormatter } from "@/components/chart-template";
import { Area, CartesianGrid, ComposedChart, Line, XAxis, YAxis } from "recharts";
import { ChartData } from "./cpi";

const cpiLabelBase = "CPI €";
const targetCpiLabelBase = "Target CPI €";

const chartConfig = {
  cpi: {
    label: cpiLabelBase,
    color: "hsl(var(--chart-1))",
  },

  ap_target_cpx_eur: {
    label: targetCpiLabelBase,
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig;

type PerformanceChartProps = {
  chartData: ChartData;
};

function CPIAchievementChart({ chartData }: PerformanceChartProps) {
  const labelFormatter = (value: string) => {
    return dailyLabelFormatter(value);
  };

  const data = chartData;
  return (
    <ChartContainer config={chartConfig}>
      <ComposedChart data={data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="dateTime" tickLine={false} axisLine={false} tickMargin={8} tickFormatter={labelFormatter} />
        <YAxis
          dataKey="cpi"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value: number) => {
            return `€ ${value}`;
          }}
        />
        <ChartTooltip cursor={false} content={<ChartTooltipContent labelFormatter={labelFormatter} />} />
        <Line dataKey="cpi" type="linear" stroke="var(--color-cpi)" strokeWidth={2} dot={false} />
        <Area
          dataKey="ap_target_cpx_eur"
          type="monotone"
          fill="var(--color-ap_target_cpx_eur)"
          fillOpacity={0.2}
          stroke="var(--color-ap_target_cpx_eur)"
          strokeWidth={2}
          dot={false}
        />
        <ChartLegend content={<ChartLegendContent />} />
      </ComposedChart>
    </ChartContainer>
  );
}

export default CPIAchievementChart;
